module.exports = __webpack_public_path__ + "static/img/default_image.ccfd913.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new_design/default_image.png
// module id = 425
// module chunks = 1